/** Chip de un mensaje o una baja del modo simulado (constancia, ficha del contacto): no salió a WhatsApp. */

import { CHIP_SIMULADO_NO_SALIO } from "../logic/textos";

export function ChipSimuladoNoSalio() {
  return <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-amber-50 text-amber-700">{CHIP_SIMULADO_NO_SALIO}</span>;
}
